import React, { useState, useEffect, useMemo, useCallback } from 'react'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Divider from '@/v2/components/common/Divider'
import TextField from '@/v2/components/common/TextField'
import { Wrapper, Item } from './styles'
import { debounce } from './debounce'
import { transformApiResponse } from '@/v2/utils/reponse-formatter'

const EligibilityItem = ({ data, searchLabel }) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [filteredData, setFilteredData] = useState([])

  useEffect(() => {
    if (data) {
      const normalizedData = transformApiResponse(data)
      setFilteredData(normalizedData)
    }
  }, [data])

  const handleSearch = useCallback(
    debounce(value => {
      setSearchTerm(value.toLowerCase())
    }, 300),
    []
  )

  const filteredResults = useMemo(() => {
    if (!filteredData.length || !searchTerm) return filteredData

    return filteredData.filter(item => {
      return item.some(({ content }) =>
        content
          .toString()
          .toLowerCase()
          .includes(searchTerm)
      )
    })
  }, [filteredData, searchTerm])

  const formatContentValue = content => {
    if (Array.isArray(content)) {
      return content.map(item => formatContentValue(item)).join(', ')
    }
    if (typeof content === 'object' && content !== null) {
      return Object.entries(content)
        .map(([key, value]) => `${key}: ${formatContentValue(value)}`)
        .join(': ')
    }
    return content
  }

  const formatContent = content => {
    if (Array.isArray(content)) {
      return content.map(item => formatContent(item)).join(' | ')
    }
    if (typeof content === 'object' && content !== null) {
      return Object.entries(content)
        .map(([key, value]) => `${key}: ${formatContentValue(value)}`)
        .join(' ')
    }
    return content
  }

  return (
    <Wrapper>
      <Grid item xs={12} mb={4}>
        <TextField
          fullWidth
          name="search"
          label={searchLabel}
          placeholder="Type to search"
          onChange={value => handleSearch(value)}
        />
      </Grid>
      {filteredResults.map((item, index) => (
        <Item key={index}>
          {item.map(({ title, content }, idx) => (
            <Grid item xs={12} mb={2} key={idx}>
              <Typography variant="h4" fontWeight={500}>
                {title}:{' '}
                <Typography variant="span" fontWeight={200}>
                  {formatContent(content)}
                </Typography>
              </Typography>
            </Grid>
          ))}
          <Divider margin="20px 0px" />
        </Item>
      ))}
    </Wrapper>
  )
}

export default EligibilityItem
